import { last } from 'lodash'

export const top = state => {
  return last(state.stack)
}
